import { h } from "preact";

import IconCategoryDesign from "../../../../library/v2/Icons/IconCategoryDesign";
import IconCategoryLayout from "../../../../library/v2/Icons/IconCategoryLayout";
import IconCategoryStyleguide from "../../../../library/v2/Icons/IconCategoryStyleguide";
import IconCategoryTextQuality from "../../../../library/v2/Icons/IconCategoryTextQuality";

enum AIReviewCategory {
    SpellingAndGrammar = "spelling_and_grammar",
    Layout = "layout",
    ContrastAA = "contrast_aa",
    ContrastAAA = "contrast_aaa",
    Color = "color",
    TextStyle = "text_style",
    Spacing = "spacing",
    ComponentUse = "component_use"
}

function getCategoryLabel(category: AIReviewCategory) {
    switch (category) {
        case AIReviewCategory.SpellingAndGrammar:
            return "Spelling and grammar";

        case AIReviewCategory.Layout:
            return "Layout";

        case AIReviewCategory.ContrastAA:
        case AIReviewCategory.ContrastAAA:
            return "Contrast";

        case AIReviewCategory.Color:
            return "Color";

        case AIReviewCategory.TextStyle:
            return "Text style";

        case AIReviewCategory.Spacing:
            return "Spacing";

        case AIReviewCategory.ComponentUse:
            return "Component use";

        default:
            return "";
    }
}

function getCategoryURLSlug(category: AIReviewCategory) {
    switch (category) {
        case AIReviewCategory.Color:
            return "project-styleguide-colors";

        case AIReviewCategory.TextStyle:
            return "project-styleguide-textstyles";

        case AIReviewCategory.Spacing:
            return "project-styleguide-spacing";

        case AIReviewCategory.ComponentUse:
            return "project-styleguide-components";

        default:
            return "";
    }
}

function getCategoryIcon(category: AIReviewCategory) {
    switch (category) {
        case AIReviewCategory.SpellingAndGrammar:
            return <IconCategoryTextQuality/>;

        case AIReviewCategory.Layout:
            return <IconCategoryLayout/>;

        case AIReviewCategory.ContrastAA:
        case AIReviewCategory.ContrastAAA:
            return <IconCategoryDesign/>;

        case AIReviewCategory.Color:
        case AIReviewCategory.TextStyle:
        case AIReviewCategory.Spacing:
        case AIReviewCategory.ComponentUse:
        default:
            return <IconCategoryStyleguide/>;
    }
}

export default AIReviewCategory;
export {
    getCategoryLabel,
    getCategoryURLSlug,
    getCategoryIcon
};
